const uploaderAnnotation = {
  state: {
    messageObj: {
      isShow: true,
      message: '数据加载中...'
    },
    floderObj: {},
    uploadTypeKey: '',
    floderData: []
  },

  mutations: {

    ANNOTATION_LOCAL_TYPE(state, data) {
      state.uploadTypeKey = data;
    },
    ANNOTATION_LOCAL_FLODER(state, data) {
      state.floderObj = data || {};
    },
    ANNOTATION_UPLOAD_FLODERDATA(state, data) {
      console.log(data);
      state.floderData = data || [];
    }

  },

  actions: {

    annotationUploadType ({ commit }, data) {
      commit('ANNOTATION_LOCAL_TYPE', data);
    },

    annotationUploadSucceedFloder ({ commit }, data) {
      commit('ANNOTATION_LOCAL_FLODER', data);
    },
    annotationUploadFloderData ({ commit }, data) {
      commit('ANNOTATION_UPLOAD_FLODERDATA', data);
    }
  }
};

export default uploaderAnnotation;
